<template>
  <div class='dialogEcharts-wrap'>
    <div class="title dn-title-bg titleZt">
      {{obj.displayName}}
      <div class="btn">
        <span class="info" @click="infoClick">详细信息</span>
      </div>
    </div>
    <div class="line dn-content-bg">
      <div :id="id" class="box"></div>
    </div>
    <!--详情弹窗-->
    <el-dialog class="infoDia" :title="obj.displayName" :visible.sync="infoDialog" width="80%" :destroy-on-close="true" :modal="false" @opened="diaOpened" @closed="diaClosed" append-to-body center>
      <div class="infoEcharts">
        <div class="linkBtn">
          <el-button class="goYxfx" @click="goYxfx" :disabled="!analysisUrl" size="small" :type="analysisUrl===''?'info':'primary'">运行分析</el-button>
        </div>
        <div class="diaEcharts" :id="diaId"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
import echarts from "echarts";
import api from '@common/api/index.js'
import dateTool from '@/utils/dateTool'
let { wsLoginState, wsRegisterNode, wsSetNodeSucc, wsSuccState, wsMsgSatet } = { wsLoginState: "101", wsRegisterNode: "102", wsSetNodeSucc: "103", wsSuccState: "104", wsMsgSatet: "105" };
/* 
wsLoginState:登录websocket状态码        wsRegisterNode:注册计量点状态码         wsSetNodeSucc:注册计量点实施状态码
wsSuccState:计量点注册成功状态码         wsMsgSatet:接收信息状态码
*/
export default {
  name: "DialogEcharts",
  props: {
    obj: {
      type: Object,
      default: () => { }
    },
    websocketData: {
      type: Object,
      default: () => { }
    },
    timeData: {
      type: Array || Object,
      default: () => []
    },
    realIndex: {
      type: Boolean,
      default: false
    },
    analysisUrl: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      id: uuidv1(),
      diaId: uuidv1(),//弹窗的echartsId
      charts: null,//echarts对象
      diaEcharts: null,//弹窗的echarts对象
      liuru: [],
      wcUrl: "",
      socket_: null,
      tempKey: "",
      echartsMap: null,//图表半小时数据
      websocketMap: null,//websocket推送过来的数据
      time: null,//定时器
      infoDialog: false,//详细信息弹窗
    };
  },
  mounted () {
    this.$nextTick(() => {
      //查询最近半小时的实时数据
      this.$once("hook:beforeDestroy", () => {//界面关闭的时候，关闭websock
        clearInterval(this.time);
      });
    });
  },
  beforeDestroy () {
    this.bus.$off("itemClick");
  },
  methods: {
    async getThisTimeData (echartsData) {//查询最近半小时的实时数据
      this.echartsMap = new Map();//初始化
      this.websocketMap = new Map();//初始化
      let { x, val, mapData } = { x: [], val: [], mapData: [] };
      console.log('echartsData', echartsData)
      echartsData.map(item => {
        //item.time
        x.push((dateTool.format(new Date(item.time), 'yyyy-MM-dd hh:mm:ss')).split(" ")[0] + '\n' + (dateTool.format(new Date(item.time), 'yyyy-MM-dd hh:mm:ss')).split(" ")[1]);
        val.push(isNaN(item.value * 1) ? item.value : (item.value * 1).toFixed(2));
        mapData.push({
          time: (dateTool.format(new Date(item.time), 'yyyy-MM-dd hh:mm:ss')).split(" ")[0] + '\n' + (dateTool.format(new Date(item.time), 'yyyy-MM-dd hh:mm:ss')).split(" ")[1],
          value: isNaN(item.value * 1) ? item.value : (item.value * 1).toFixed(2)
        });
      });
      //replace(/-/g, "/")) //转/      replace(/\//g, "-")/-
      this.tempKey = this.obj.measuresId + '_' + this.obj.pointNumber + '_' + this.obj.pointCode;//保存当前key
      this.echartsMap.set(this.tempKey, JSON.parse(JSON.stringify(mapData)));//保存当前的图表数据
      this.$emit("updateData", {//获取最新的一条数据返回给父组件
        [this.obj.displayName]: val.length == 0 ? "-" : val[val.length - 1],
      });
      this.fillCharts(x, val);
      //开启一秒定时推送
      this.time = setInterval(() => {
        this.formatEchartsData();//处理数据
      }, 1000);
    },
    getTime (nowDate) {//获取时间参数信息
      let year = nowDate.getFullYear();
      let month = (nowDate.getMonth() + 1) <= 9 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
      let day = nowDate.getDate() <= 9 ? '0' + nowDate.getDate() : nowDate.getDate();
      let hourse = nowDate.getHours() <= 9 ? '0' + nowDate.getHours() : nowDate.getHours();
      let Min = nowDate.getMinutes() <= 9 ? '0' + nowDate.getMinutes() : nowDate.getMinutes();
      let sec = nowDate.getSeconds() <= 9 ? '0' + nowDate.getSeconds() : nowDate.getSeconds();
      let thisTime = year + '-' + month + '-' + day + ' ' + hourse + ':' + Min + ':' + sec;
      return thisTime;
    },
    webSocketMsg (e) {
      if (e.methodCode == wsMsgSatet) {//获取到推送的数据
        let tempData = e.data.filter(item => item.measureId === this.obj.measuresId);
        //1、判断当前推送的数据跟当前时间(半小时范围)对比，避免推送历史数据
        if (tempData.length > 0 && this.screenTime(tempData[0].time)) {//符合半小时
          if (this.websocketMap) {
            let temp = this.websocketMap.get(this.tempKey) || [];
            let findIdData = e.data.find(item => item.measureId === this.obj.measuresId);
            if (findIdData) {//如果存在当前id的推送数据
              let findCodeData = findIdData.data.find(item => item.pointCode == this.obj.pointCode) //查找指定的code数据，先写死214，后面换成对应的
              if (findCodeData) {
                temp.push({
                  value: isNaN(findCodeData.value * 1) ? '-' : (findCodeData.value * 1).toFixed(2),
                  time: (dateTool.format(new Date(findIdData.time), 'yyyy-MM-dd hh:mm:ss')).split(' ')[0] + '\n' + (dateTool.format(new Date(findIdData.time), 'yyyy-MM-dd hh:mm:ss')).split(' ')[1]
                });
                this.websocketMap.set(this.tempKey, JSON.parse(JSON.stringify(temp)));
              }
            }
          }
        }
      }
    },
    screenTime (time) {//筛选时间
      let date = new Date();
      time.split('\n').length > 1 ? time = time.split('\n')[0] + ' ' + time.split('\n')[1] : '';
      let thisTime = date.getTime();//当前时间戳
      time = new Date(time).getTime();//参数时间戳
      if (thisTime - time > 30 * 60 * 1000) {//超过时间范围
        return false;
      }
      return true;
    },
    formatEchartsData () {//处理数据
      let data = this.websocketMap.get(this.tempKey) || [];
      let [echartsX, echartsSeries] = [[], []];
      let echartsData = this.echartsMap.get(this.tempKey);
      echartsData.map(item => {//获取以前的echarts数据
        echartsX.push(item.time);
        echartsSeries.push(item.value);
      });
      //筛选现有的echarts数据，是否有超过半小时范围的
      let [newEchartsX, newEchartsSeries] = [[], []];
      echartsX.map((item, key) => {
        if (this.screenTime(item)) {//将没有超时的数据重新保存下来
          newEchartsX.push(item);
          newEchartsSeries.push(echartsSeries[key]);
        }
      });
      //筛选现有的echarts数据，是否有超过半小时范围的
      if (data.length > 0) {//如果有websocket内有新的合法数据
        let series = [];
        data.map(item => {
          newEchartsX.push(item.time);
          newEchartsSeries.push(item.value);
        });
      }
      //判断数据是否有更新
      if (echartsX.length > 0 && newEchartsX.length > 0 && echartsX.slice(-1)[0] != newEchartsX.slice(-1)[0]) {//x轴存在更新
        this.charts.setOption({
          xAxis: {
            data: newEchartsX
          },
          series: [{
            data: newEchartsSeries
          }]
        });
        this.$emit("updateData", {
          //获取最新的一条数据返回给父组件
          [this.obj.displayName]: newEchartsSeries.length == 0 ? "-" : newEchartsSeries[newEchartsSeries.length - 1],
        });
        //判断详细信息弹窗有没有打开
        if (this.infoDialog) {
          this.diaEcharts.setOption({
            xAxis: {
              data: newEchartsX
            },
            series: [{
              data: newEchartsSeries
            }]
          });
        }
      }
      //更新echarts的数据
      let newEchartsMap = [];
      newEchartsX.map((item, key) => {
        newEchartsMap.push({
          time: item,
          value: newEchartsSeries[key]
        })
      });
      this.echartsMap.set(this.tempKey, JSON.parse(JSON.stringify(newEchartsMap)));
      //删除websocket储存的数据
      this.websocketMap.set(this.tempKey, JSON.parse(JSON.stringify([])));
    },
    fillCharts (x, val) {
      //alert(x)
      console.log(x)
      this.charts = echarts.init(document.getElementById(this.id));
      let option = {
        grid: {
          left: 10,
          right: 40,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        color: [this.obj.color],
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: x,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "666"
            }
          },
          axisTick: {
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            color: "#666"
          }
        },
        yAxis: {
          type: 'value',
          name: this.obj.company,
          nameTextStyle: {
            color: "#2e3842"
          },
          axisLine: {
            lineStyle: {
              color: "#666"
            }
          },
          axisTick: {
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            color: "#666"
          },
          min: function (value) {
            if (Number(value.min) < 0) {
              return Math.ceil(Number(value.min) / 0.95);
            } else {
              return Math.floor(Number(value.min) * 0.95);
            }
          },
          max: function (value) {
            if (Number(value.max) < 0) {
              return Math.floor(Number(value.max) / 1.05);
            } else {
              return Math.ceil(Number(value.max) * 1.05);
            }
          }
        },
        series: [{
          data: val,
          type: 'line',
          symbol: "none",
          smooth: true
        }]
      };
      this.charts.setOption(option);
    },
    infoClick () {//详细信息
      this.infoDialog = true;//开启弹窗
    },
    diaOpened () {//弹窗打开结束回调
      let options = this.charts.getOption();//获得当前点击的echarts的配置信息
      this.fillDiaEcharts({
        color: options.color[0],
        x: options.xAxis[0].data,
        series: [{
          data: options.series[0].data,
          type: 'line',
          symbol: "none",
          smooth: true
        }]
      })
    },
    diaClosed () {//弹窗关闭结束回调
      this.diaEcharts && this.diaEcharts.clear();
      this.realIndex = false;
      this.diaEcharts = null;
    },
    fillDiaEcharts (obj) {//渲染弹窗的echarts
      this.diaEcharts && this.diaEcharts.clear();
      this.diaEcharts = echarts.init(document.getElementById(this.diaId));
      let option = {
        grid: {
          left: 10,
          right: 40,
          bottom: 50,
          top: 40,
          containLabel: true
        },
        color: [obj.color],
        tooltip: {
          trigger: 'axis'
        },
        dataZoom: [{
          show: true,
          start: 0,
          end: 100
        }, {
          type: 'inside',
          realtime: true,
          start: 0,
          end: 100
        }],
        xAxis: {
          type: 'category',
          data: obj.x,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "666"
            }
          },
          axisTick: {
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            color: "#666"
          }
        },
        yAxis: {
          type: 'value',
          name: this.obj.company,
          nameTextStyle: {
            color: "#2e3842"
          },
          axisLine: {
            lineStyle: {
              color: "#666"
            }
          },
          axisTick: {
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            color: "#666"
          },
          min: function (value) {
            if (Number(value.min) < 0) {
              return Math.ceil(Number(value.min) / 0.95);
            } else {
              return Math.floor(Number(value.min) * 0.95);
            }
          },
          max: function (value) {
            if (Number(value.max) < 0) {
              return Math.floor(Number(value.max) / 1.05);
            } else {
              return Math.ceil(Number(value.max) * 1.05);
            }
          }
        },
        series: obj.series
      };
      this.diaEcharts.setOption(option);
    },
    goYxfx () {//跳转到运行分析
      parent.postMessage({
        type: 'GO_TO_PAGE', page: this.analysisUrl, query: {
          measureId: this.obj.measuresId,
          code: this.obj.pointCode
        }
      }, '*');
    }
  },
  watch: {
    websocketData: {
      handler (newVal, oldVal) {
        this.$nextTick(() => {
          this.webSocketMsg(newVal);
        });
      },
      deep: true
    },
    timeData: {
      handler (newVal, oldVal) {
        this.$nextTick(() => {
          this.getThisTimeData(newVal);
        });
      },
      deep: true
    },
    realIndex (newVal, oldVal) {
      if (newVal) {
        this.infoClick();
      }
    }
  },
}
</script>

<style lang='scss' scoped>
.dialogEcharts-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  border-radius: 4px;
  .title {
    font-weight: bold;
    color: #2e3842;
    height: 30px;
    line-height: 30px;
    padding: 0px 10px;
    box-sizing: border-box;
    position: relative;
    .btn {
      position: absolute;
      right: 5px;
      top: 0;
      .goYxfx,
      .info {
        display: inline-block;
        padding: 0 5px;
        color: #fff;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .line {
    flex: 1;
    width: 100%;
    .box {
      width: 100%;
      height: 100%;
      border-radius: 0;
    }
  }
  .infoDia {
    display: flex;
    align-items: center;
  }
}
.infoEcharts {
  width: 100%;
  height: 600px;
  background: #fff;
  display: flex;
  flex-flow: column;
  .linkBtn {
    margin: 5px;
  }
  .diaEcharts {
    width: 100%;
    flex: 1;
  }
}
</style>
<style scoped>
.infoDia >>> .el-dialog__header {
  background: #0197ee;
  height: 36px;
  box-sizing: border-box;
  padding: 0 10px;
  text-align: left;
  position: relative;
}
.infoDia >>> .el-dialog__headerbtn {
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
}
.infoDia >>> .el-dialog__title {
  line-height: 36px;
  color: #fff;
}
.infoDia >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.infoDia >>> .el-dialog.el-dialog--center {
  margin-top: 13vh !important;
}
</style>